// extracted by mini-css-extract-plugin
module.exports = {"commentSectionContainer":"PanelSection__commentSectionContainer--1d5pp"};